// Frontend client for POST /api/parse — turns one short sentence into draft events
// for the caretaker to confirm before commit.

import { supabase } from "./supabase";
import { runtimeLocale } from "./i18n/runtimeLocale";

export type DraftEvent =
  | { kind: "feed"; method: "bottle" | "breast"; amountOz?: number; durationMin?: number; side?: "L" | "R" | "both"; at: string }
  | { kind: "sleep"; live: boolean; at: string; endAt?: string }
  | { kind: "wake"; at: string }
  | { kind: "diaper"; diaperKind: "wet" | "dirty" | "both"; at: string }
  | { kind: "weight"; lb: number; oz: number; at: string }
  | { kind: "note"; text: string; at: string };

export type ParseResponse =
  | { ok: true; events: DraftEvent[]; clarify?: string; remaining?: number }
  | { ok: false; reason: string; remaining?: number };

export async function parseEvent(babyId: string, text: string): Promise<ParseResponse> {
  const now = new Date();
  const { data } = await supabase.auth.getSession();
  const resp = await fetch("/api/parse", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      ...(data.session ? { authorization: `Bearer ${data.session.access_token}` } : {}),
    },
    body: JSON.stringify({
      babyId,
      text,
      nowIso: now.toISOString(),
      tzOffsetMinutes: now.getTimezoneOffset(),
      locale: runtimeLocale(),
    }),
  });
  try {
    const body = (await resp.json()) as ParseResponse;
    return body;
  } catch {
    return { ok: false, reason: "bad-response" };
  }
}
